module.exports = __webpack_public_path__ + "static/media/excel.0aab425c.png";